/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  OTELLogsPayload,
  OTELLogsPayload$Outbound,
  OTELLogsPayload$outboundSchema,
} from "../components/otellogspayload.js";

export type HooksNumberLogsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type HooksNumberLogsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  otelLogsPayload: OTELLogsPayload;
};

/** @internal */
export type HooksNumberLogsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const HooksNumberLogsSecurity$outboundSchema: z.ZodMiniType<
  HooksNumberLogsSecurity$Outbound,
  HooksNumberLogsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberLogsSecurityToJSON(
  hooksNumberLogsSecurity: HooksNumberLogsSecurity,
): string {
  return JSON.stringify(
    HooksNumberLogsSecurity$outboundSchema.parse(hooksNumberLogsSecurity),
  );
}

/** @internal */
export type HooksNumberLogsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  OTELLogsPayload: OTELLogsPayload$Outbound;
};

/** @internal */
export const HooksNumberLogsRequest$outboundSchema: z.ZodMiniType<
  HooksNumberLogsRequest$Outbound,
  HooksNumberLogsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    otelLogsPayload: OTELLogsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      otelLogsPayload: "OTELLogsPayload",
    });
  }),
);

export function hooksNumberLogsRequestToJSON(
  hooksNumberLogsRequest: HooksNumberLogsRequest,
): string {
  return JSON.stringify(
    HooksNumberLogsRequest$outboundSchema.parse(hooksNumberLogsRequest),
  );
}
